function l(r, t) {
  if (r.length !== t.length)
    return !1;
  const n = r.length;
  for (let e = 0; e < n; e++)
    if (r[e] !== t[e])
      return !1;
  return !0;
}
export {
  l as isEqualNumberArray
};
//# sourceMappingURL=index2.js.map
